module.exports = __webpack_public_path__ + "static/media/tb-lfriedel.604742b7.jpeg";